import DeleteIcon from '@mui/icons-material/Delete';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import React from 'react';

import ApiRequest from '../../api/request';
import { Confirm } from './Confirmation';

type DeleteButtonProps = {
  data: any[];
  model: string;
  token?: string;
  tableDidFinishLoading: (action: any, message: string | null, error: string | undefined) => void;
  tableDidStartLoading: () => void;
};

function DeleteButton({
  data,
  model,
  token,
  tableDidStartLoading,
  tableDidFinishLoading,
}: DeleteButtonProps) {
  return (
    <Tooltip title="Delete selected rows">
      <IconButton
        onClick={async () => {
          console.log('DeleteButton.onClick()');
          const message = 'Are you sure you want to delete the selected record(s)?';
          const confirmed = await Confirm(message);
          if (confirmed) {
            tableDidStartLoading();

            const action = {
              type: 'delete',
              data: null,
            };

            const params = { model, id: data };
            try {
              const response = await ApiRequest.sendRequest({
                method: 'post',
                params,
                path: 'data/delete',
                token,
              });
              tableDidFinishLoading(action, response.data.message, response.data.error);
            } catch (err: any) {
              console.log(`DeleteButton err:${err}\nStack:\n${err.stack}`);
              tableDidFinishLoading(
                action,
                null,
                'An error has occurred, please try again or contact support.',
              );
            }
          }
        }}
        aria-label="row">
        <DeleteIcon />
      </IconButton>
    </Tooltip>
  );
}

export default DeleteButton;
